import { giphyDarkestGrey, giphyLightGrey } from '@giphy/colors'
import { ReactNode } from 'react'
import { CloseButton, Container, Description, Header, Sticker, Title } from './style'

type Props = {
    children?: ReactNode
    className?: string
    description?: string
    stickerUrl?: string
    title: string
    onClose?: () => void
}

const Alert = ({ children, className, description, stickerUrl, title, onClose }: Props) => (
    <Container className={className} hasSticker={!!stickerUrl}>
        {stickerUrl && <Sticker src={stickerUrl} alt="" />}
        <Header>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
        </Header>
        {children}
        {onClose && (
            <CloseButton
                color={giphyDarkestGrey}
                icon="close"
                iconColor={giphyLightGrey}
                iconScale={0.9}
                size="medium"
                onClick={() => onClose()}
            />
        )}
    </Container>
)

export default Alert
